import React from "react";
import styled from "styled-components";
import bar from "../assets/images/cover/bar.png";
import PropTypes from "prop-types";
import Colors from "../utils/colors";

const Wrapper = styled.div`
  background-image: url(${bar});
  background-position: center;
  background-size: cover;
  width: 100vw;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    font-size: 2rem;
    text-align: center;
    color: ${Colors.WHITE};
    margin: 20px 50px;
    text-shadow: 2px 2px 8px #707070;
  }

  @media screen and (min-width: 768px) {
    h1 {
      font-size: 4rem;
      margin: 20px 20%;
    }
  }

  @media screen and (min-width: 1224px) {
    h1 {
      font-size: 4rem;
      margin: 20px 30%;
    }
  }
`;

const Separator = ({ text }) => {
  return (
    <Wrapper>{text && <h1 className="font-special-black">{text}</h1>}</Wrapper>
  );
};

Separator.propTypes = {
  text: PropTypes.string,
};
export default Separator;
